
import CompanyAlbum from '@/components/Companies/Album.vue'
import Faqs from '@/components/Companies/FAQ.vue'
import LazyListNews from '@/components/Companies/ListNews.vue'
import LazyDialogApplyWithCv from '@/components/DialogModal/ApplyWithCV.vue'
import LazyModalNotificationSuccess from '@/components/DialogModal/ModalNotificationSuccess.vue'
import LazyDialogApplyWithoutCv from '@/components/DialogModal/ApplyWithOutCV.vue'
import InformationCompany from '@/components/JobDetail/InformationCompany.vue'
import JobDescription from '@/components/JobDetail/JobDescription.vue'
import JobSubInformation from '@/components/JobDetail/JobSubInformation.vue'
import ListJobsForCompany from '@/components/JobDetail/ListJobsForCompany.vue'
import CardBlog from '@/components/JobDetail/CardBlog.vue'
import Mixin from '@/mixins'
import { EventType, JobType } from '@/models/enums'
import {
  Job,
  JOB_DISPLAY_STATUS_CLOSED,
  JOB_DISPLAY_STATUS_IN_REVIEW,
  JOB_DISPLAY_STATUS_OPEN,
} from '@/models/job'
import { User } from '@/models/user'
import AppModule from '@/store/app'
import JobsModule from '@/store/jobs'
import SettingsModule from '@/store/settings'
import ToastModule from '@/store/toast'
import UserModule from '@/store/user'
import { addClassListPopup } from '@/utils'
import { Component, mixins, Prop, Watch } from 'nuxt-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({
  name: 'BoxCard',
  components: {
    ListJobsForCompany,
    LazyListNews,
    JobDescription,
    JobSubInformation,
    InformationCompany,
    LazyDialogApplyWithCv,
    LazyDialogApplyWithoutCv,
    LazyModalNotificationSuccess,
    CompanyAlbum,
    Faqs,
    CardBlog,
  },
})
export default class BoxCard extends mixins(Mixin) {
  count: number = this.totalJobsFirstCompany
  cardId: string = ''

  isShowNews: boolean = false
  isShowContent: boolean = true

  isProcessFollowing = false
  benefits: any[] = []

  @Prop({ required: true, type: Object }) readonly job: Job
  @Prop({ required: false, type: Function }) setIsActive: Function

  get jobDisplayStatusClosed(): string {
    return JOB_DISPLAY_STATUS_CLOSED
  }

  get jobDisplayStatusReview(): string {
    return JOB_DISPLAY_STATUS_IN_REVIEW
  }

  get jobDisplayStatusOpen(): string {
    return JOB_DISPLAY_STATUS_OPEN
  }

  get isJobClosed(): boolean {
    return this.job.status_display === JOB_DISPLAY_STATUS_CLOSED
  }

  get language(): string {
    return getModule(AppModule, this.$store).language
  }

  get isVisibleDialogWithCv() {
    return getModule(SettingsModule, this.$store).isVisibleDialogWithCV
  }

  get isVisibleDialogWithOutCv() {
    return getModule(SettingsModule, this.$store).isVisibleDialogWithOutCV
  }

  get isVisibleDialogNotification() {
    return getModule(SettingsModule, this.$store).isVisibleDialogNotification
  }

  get isAuth() {
    return getModule(UserModule, this.$store).isAuth
  }

  get userProfile(): User {
    return getModule(UserModule, this.$store).profile
  }

  get currentJob() {
    return getModule(JobsModule, this.$store).currentJob
  }

  get totalJobsFirstCompany() {
    return getModule(JobsModule, this.$store).totalFirstCompany
  }

  get currentJobId() {
    return getModule(JobsModule, this.$store).currentJobId
  }

  get recruitmentProcess() {
    if (this.job.recruiment_process && this.job.recruiment_process.length > 0) {
      return this.job.recruiment_process
    }

    if (
      this.job.company?.recruitment_process &&
      this.job.company?.recruitment_process.length > 0
    ) {
      return this.job.company.recruitment_process
    }

    return []
  }

  get imageGalleries() {
    const images: any = this.job.company?.image_galleries || []
    return images.map((item: any) => {
      return {
        name: this.job.company?.display_name,
        url: item.url,
      }
    })
  }

  get isValidJobToApply(): boolean {
    if (
      this.currentJobId === this.job.id &&
      this.job.status_display === this.jobDisplayStatusOpen
    ) {
      return true
    }
    return false
  }

  countedNumJobs(total: number) {
    this.count = total
  }

  handleShowTabNews(): void {
    this.isShowNews = true
    this.isShowContent = false
  }

  handleShowTabContent(): void {
    this.isShowNews = false
    this.isShowContent = true
  }

  handleShowDialogWithCV(jobId: number) {
    if (this.userProfile.roles && this.userProfile.roles[0] === 'employer') {
      this.setIsActive(true)
      return
    }
    if (!this.$route.query.source) {
      this.$router.push({
        path: '',
        query: {
          ...this.$route.query,
          source: 'ApplyNow',
        },
      })
    }
    getModule(JobsModule, this.$store).setCurrentJobId(jobId)
    getModule(SettingsModule, this.$store).showDialogWithCV(true)
    addClassListPopup('layer-popup')

    // Tracking apply-now
    this.$repositories.activities.tracking({
      job_ids: this.job.id,
      collection: 'apply-now',
    })

    // Push GTM on click Apply Now
    const { app } = this.$nuxt.context
    app.$gtm.push({
      event: 'eec.jobApply',
      ecommerce: {
        add: {
          actionField: { list: 'ApplyCV' },
          products: [
            {
              name: this.job.detail_url,
              id: this.job.id,
              brand: this.job?.company?.display_name,
              category: 'Job',
              variant: this.job.job_types_str,
            },
          ],
        },
      },
    })
  }

  handleShowDialogWithOutCV(jobId: number) {
    if (this.userProfile.roles && this.userProfile.roles[0] === 'employer') {
      this.setIsActive(true)
      return
    }
    getModule(JobsModule, this.$store).setCurrentJobId(jobId)
    getModule(SettingsModule, this.$store).showDialogWithOutCV(true)
    addClassListPopup('layer-popup')

    // Tracking apply-now
    this.$repositories.activities.tracking({
      job_ids: this.job.id,
      collection: 'apply-without-cv',
    })

    // Push GTM on click Apply Now
    const { app } = this.$nuxt.context
    app.$gtm.push({
      event: 'eec.jobApply',
      ecommerce: {
        add: {
          actionField: { list: 'ApplyWithoutCV' },
          products: [
            {
              name: this.job.detail_url,
              id: this.job.id,
              brand: this.job.company?.display_name,
              category: 'Job',
              variant: this.job.job_types_str,
            },
          ],
        },
      },
    })
  }

  handleShowApplyWithTopDevCV(jobId: number) {
    if (this.userProfile.roles && this.userProfile.roles[0] === 'employer') {
      this.setIsActive(true)
      return
    }

    getModule(JobsModule, this.$store).setCurrentJobId(jobId)

    let path = this.$t('routes.detail_job', {
      slug: this.job.slug,
      id: this.job.id,
    })

    // Append path with utm
    if (this.$nuxt.$route.params.slug === this.job.slug + '-' + this.job.id) {
      path = this.$nuxt.$route.fullPath
    }

    this.openCVBuilderAndPopupCreate(path)

    // Tracking apply-now
    this.$repositories.activities.tracking({
      job_ids: this.job.id,
      collection: 'apply-with-topdev-cv',
    })

    // Push GTM on click Apply Now
    const { app } = this.$nuxt.context
    app.$gtm.push({
      event: 'eec.jobApply',
      ecommerce: {
        add: {
          actionField: { list: 'ApplyWithTopDevCV' },
          products: [
            {
              name: this.job.detail_url,
              id: this.job.id,
              brand: this.job.company?.display_name,
              category: 'Job',
              variant: this.job.job_types_str,
            },
          ],
        },
      },
    })
  }

  handleScrollToBenefit(jobId: number) {
    document
      .getElementById(`benifit-${jobId}`)
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  handleFollowJob(jobId: number) {
    if (this.userProfile.roles && this.userProfile.roles[0] === 'employer') {
      this.setIsActive(true)
      return
    }

    if (this.isJobClosed) {
      return
    }

    if (!this.isAuth) {
      this.openLoginPopup()
      return
    }

    if (this.isProcessFollowing) {
      return
    }

    this.isProcessFollowing = true
    const data = {
      id: jobId,
    }

    this.$repositories.jobs
      .followJobApi(data)
      .then((res: any) => {
        getModule(JobsModule, this.$store).setNewJob({
          jobId: res.data.data.id,
          caseType: JobType.follow,
        })

        if (res.data.message === 'Have followed') {
          getModule(ToastModule, this.$store).showToast({
            type: EventType.SUCCESS,
            message: this.$i18n.t('text.your_are_followed_job', {
              jobTitle: this.job.title,
            }),
            options: {},
          })
        } else {
          getModule(ToastModule, this.$store).showToast({
            type: EventType.WARNING,
            message: this.$i18n.t('text.your_are_unfollow_job', {
              jobTitle: this.job.title,
            }),
            options: {},
          })
        }

        this.isProcessFollowing = false
      })
      .catch((error: any) => {
        getModule(ToastModule, this.$store).showToast({
          type: EventType.ERROR,
          message: this.$i18n.t('text.your_are_follow_error'),
          options: {},
        })

        this.$sentry.captureException(error)

        this.isProcessFollowing = false
      })
  }

  handleShare() {
    const currentUrl = process.env.DOMAIN_NAME + this.$nuxt.$route.path

    window.open(
      'http://facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(currentUrl),
      '',
      'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
    )
  }

  mounted() {
    this.cardId = 'card_' + this.job.id

    if (getModule(AppModule, this.$store).device === 'Desktop') {
      // https://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
      setTimeout(() => {
        const cardEl =
          document.getElementById(this.cardId) || document.createElement('div')
        const sideWrap =
          cardEl.querySelector<HTMLElement>('.side-wrap') ||
          document.createElement('div')

        sideWrap.style.minHeight = sideWrap.offsetHeight.toString() + 'px'
      }, 0)
    }

    // Get total job count
    if (this.job.company?.id) {
      this.$repositories.companies
        .fetchCompanyOpenJobCount(this.job.company?.id)
        .then((response: any) => {
          if (response.status === 200 || response.data) {
            const countJob = response.data?.data?.num_job_openings | 1

            this.countedNumJobs(countJob)
          }
        })
        .catch((error: any) => this.$sentry.captureException(error))
    }

    // Mounting benefits
    this.benefits = this.job.company?.benefits

    if (this.job && this.job.benefits && this.job.benefits.length > 0) {
      this.benefits = this.job.benefits
    }

    //  Tracking view
    this.$repositories.activities.tracking({
      job_ids: this.job.id,
      collection: 'view',
    })

    // Push GTM
    const { app } = this.$nuxt.context

    app.$gtag('event', 'page_view', {
      send_to: 'AW-820839712',
      dynx_itemid: this.job.id,
      dynx_pagetype: 'offerdetail',
      job_id: this.job.id,
      job_locid: this.job.addresses?.address_region_list,
      job_pagetype: 'offerdetail',
    })

    app.$gtm.push({
      event: 'eec.detailView',
      nonInteraction: true,
      ecommerce: {
        detail: {
          products: [
            {
              name: this.job.detail_url,
              id: this.job.id,
              brand: this.job.company?.display_name || '',
              category: 'Job',
              variant: this.job.job_types_str,
            },
          ],
        },
      },
    })
  }

  @Watch('userProfile')
  watchUserProfile() {
    // Check to open apply
    if (
      (this.$cookies.get('selectedCV') ||
        this.$route.query.openPopupApply === '1') &&
      this.job.id &&
      this.job.status_display === this.jobDisplayStatusOpen
    ) {
      this.handleShowDialogWithCV(parseInt(this.job.id + ''))
    }
  }

  handleGoToJobList() {
    if (this.isShowContent === false) {
      this.handleShowTabContent()
      return
    }

    if (this.count === 1) {
      return
    }
    const cardElement = document.querySelector(
      `#card-job-${this.job.id}`
    ) as HTMLElement
    const listJobElement = cardElement.querySelector(
      `#list-job-${this.job.id}`
    ) as HTMLElement

    const offset =
      getModule(AppModule, this.$store).device === 'Desktop' ? 0 : 190

    window.scrollTo({
      top: cardElement.offsetTop + listJobElement.offsetTop + offset,
      behavior: 'smooth',
    })
  }
}
